import React, { useState, useEffect } from "react";
import axios from 'axios';
import './../styles/ecom.css';
import './../styles/ecom/contacto.css';
import * as globals from './../components/GlobalScripts.js';
import NavbarTop from './ecom/Navbartop';
import Footer from './ecom/Footer';

import banner1 from './../components/contacto.webp';

const Contacto = () => {
    const [nombre, setNombre] = useState('');
    const [correo, setCorreo] = useState('');
    const [asunto, setAsunto] = useState('');
    const [mensaje, setMensaje] = useState('');

    let path_api = localStorage.getItem('path_api');

    useEffect(() => {
        const fetchFacebookData = async () => {
            let facebookParams = globals.facebookParams();
            let event_source_url = facebookParams.event_source_url;
            let client_user_agent = facebookParams.client_user_agent;
            let event_time = facebookParams.event_time;
            let facebookPixel = facebookParams.facebookPixel;
            let facebookToken = facebookParams.facebookToken;
            let event_id = facebookParams.event_id;

            let data = {
                "event_source_url": event_source_url,
                "event_time": event_time,
                "client_user_agent": client_user_agent,
                "hostedBy": "Zadrig"
            };

            await window.fbq('track', 'PageView', data, { eventID: event_id });

            let fbp = facebookParams.fbp;
            let fbc = facebookParams.fbc;

            await fetch('https://zadrig.com/facebook/eventos/ecommerce.zadrigman/pageview.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    event_id: event_id,
                    facebookPixel: facebookPixel,
                    facebookToken: facebookToken,
                    event_time: event_time,
                    fbp: fbp,
                    fbc: fbc,
                    event_source_url: event_source_url,
                    client_user_agent: client_user_agent
                }),
            });
        };

        fetchFacebookData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const inputs = document.querySelector('form').querySelectorAll('input, textarea');
        let valid = true;

        inputs.forEach(input => {

            if (valid && !input.value.trim()) {
                globals.createAlert({ type: "error", msg_title: "Falta información", msg: `El campo ${input.name} es obligatorio.`, effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
                input.classList.add('requiered-outline');
                valid = false;
            } else if (valid) {
                input.classList.remove('requiered-outline');
            }
        });

        if (!valid) return;

        globals.openViewCharge();

        await axios.post(`${path_api}/ecom/contacto.php`, {
            nombre,
            correo,
            asunto,
            mensaje,
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === "success") {
                globals.createAlert({ type: "success", msg_title: "Enviado", msg: "Tu mensaje ha sido enviado exitosamente.", effect: "opacidad 2s, desplazamiento 2s" });
                setNombre('');
                setCorreo('');
                setAsunto('');
                setMensaje('');
            } else if (response.data.mensaje) {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje, effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: "Si persiste, informe al soporte.", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Hubo un problema al enviar tu mensaje. Intenta de nuevo.", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });

        globals.closeViewCharge();
    };

    return (
        <div className="app-ecom app-container">
            <NavbarTop />
            <div className="main-content page-contacto">
                <div className="slider">
                    <div className="slide" style={{ backgroundImage: `url(${banner1})` }}>
                        <div className='overlay-slider'></div>
                        <div className="content">
                            <h1>¿Tienes alguna pregunta?</h1>
                            <p>¡Estamos aquí para ayudarte! Contáctanos y te responderemos lo antes posible.</p>
                        </div>
                    </div>
                </div>
                <div className="page-container">
                    <div className='container-section flex-column center gap-20'>
                        <h1 className="no-margin">¡Queremos saber de ti!</h1>

                        <form onSubmit={handleSubmit}>
                            <div className="group-column">
                                <label className="requiered-input">Nombre</label>
                                <input type="text" name="nombre" className="input-primary" value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Tu nombre" />
                            </div>

                            <div className="group-column">
                                <label className="requiered-input">Correo</label>
                                <input type="email" name="correo" className="input-primary" value={correo} onChange={(e) => setCorreo(e.target.value)} placeholder="tuemail@correo.com" />
                            </div>

                            <div className="group-column">
                                <label className="requiered-input">Asunto</label>
                                <input type="text" name="asunto" className="input-primary" value={asunto} onChange={(e) => setAsunto(e.target.value)} placeholder="Asunto del mensaje" />
                            </div>

                            <div className="group-column">
                                <label className="requiered-input">Mensaje</label>
                                <textarea name="mensaje" className="input-primary" value={mensaje} onChange={(e) => setMensaje(e.target.value)} placeholder="Escribe tu mensaje aquí..." rows="5"></textarea>
                            </div>

                            <div className="flex-row justify-end gap-20">
                                <button className="button-primary" type="submit">Enviar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Contacto;
